module.exports = __webpack_public_path__ + "img/code.8d7e2a4c.png";